import * as React from 'react'
import I18n from '../../../../core/i18n'
import { adminService } from '../../../../core/services'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { InputText, InputTextArea, ListItem, Select, Toggle } from '../../../atoms'
import * as interfaces from '../../../../static/interfaces'
import AdminLayoutEdit from '../_layouts/edit'
import ReactSelect from 'react-select'

declare var window: interfaces.IWindow

interface IProps {
  tags: IJsonResponse
  categories: IJsonResponse
  areas: IJsonResponse
}

const FIELDS = {
  slug: 'slug',
  is_parent: 'is_parent',
  feature_type: 'feature_type',
  title: 'title',
  detail_title: 'detail_title',
  description: 'description',
  detail_description: 'detail_description',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('feature', { scope: 'activerecord.models' }),
})

const AdminFeatureNew: React.FC<IProps> = props => {
  const [image, setImage] = React.useState(null)

  const convertArrayToOptions = array => {
    return array.map(item => {
      return {
        value: item?.attributes?.id,
        label: item?.attributes?.name,
      }
    })
  }
  const areaOptions = convertArrayToOptions(props?.areas?.data ?? [])
  const categoryOptions = convertArrayToOptions(props?.categories?.data ?? [])
  const tagOptions = convertArrayToOptions(props?.tags?.data ?? [])

  const [areas, setAreas] = React.useState([])
  const [categories, setCategories] = React.useState([])
  const [tags, setTags] = React.useState([])

  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const formValues = {
        ...values,
        area_ids: areas.map(({ value }) => value),
        category_ids: categories.map(({ value }) => value),
        tag_ids: tags.map(({ value }) => value),
      }
      const formData = new FormData()
      Object.keys(formValues).forEach(key => {
        formData.append(`feature[${key}]`, values[key])
      })
      const { createdFeature, flush } = await adminService.createFeature(formValues)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/admin/features'
    },
    [areas, categories, tags]
  )

  return (
    <AdminLayoutEdit
      model="feature"
      title={title}
      fields={FIELDS}
      indexLink="/admin/features"
      formItems={
        <>
          <ListItem>
            <InputText required={true} name="slug" label={I18n.t('generic.slug')} />
          </ListItem>
          <ListItem>
            <Toggle name="is_parent" label="Is parent" />
          </ListItem>
          <ListItem>
            <Select
              required={true}
              defaultValue="area"
              name="feature_type"
              label="Feature type"
              options={[
                { value: 'area', label: 'area' },
                { value: 'category', label: 'category' },
              ]}
            />
          </ListItem>
          <ListItem>
            <InputText required={true} name="title" label={I18n.t('generic.title')} />
          </ListItem>
          <ListItem>
            <InputTextArea
              required={true}
              name="description"
              label={I18n.t('generic.description')}
            />
          </ListItem>
          <ListItem>
            <InputText required={true} name="detail_title" label={I18n.t('generic.detail_title')} />
          </ListItem>
          <ListItem>
            <InputTextArea
              required={true}
              name="detail_description"
              label={I18n.t('generic.detail_description')}
            />
          </ListItem>
          <ListItem>
            <ReactSelect
              options={areaOptions}
              isMulti={true}
              title={I18n.t('generic.areas')}
              onChange={setAreas}
              menuPortalTarget={document.querySelector('body')}
            />
          </ListItem>
          <ListItem>
            <ReactSelect
              options={categoryOptions}
              isMulti={true}
              title={I18n.t('generic.categories')}
              onChange={setCategories}
              menuPortalTarget={document.querySelector('body')}
            />
          </ListItem>
          <ListItem>
            <ReactSelect
              options={tagOptions}
              isMulti={true}
              title={I18n.t('generic.tags')}
              onChange={setTags}
              menuPortalTarget={document.querySelector('body')}
            />
          </ListItem>
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminFeatureNew
